import Image from './Image';

const PhotoList = ({ files, isMobile }) => (
  <div className="row text-center text-lg-left">
    {files.map((x, i) => (
      <div className="col-lg-3 col-md-4 col-6" key={i}>
        <Image
          canRotate={x.canRotate}
          isMobile={isMobile}
          src={`/files/${x.filename}`}
        />
      </div>
    ))}
  </div>
);

export default PhotoList;
